import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getConversationById } from 'src/redux/thunks/conversation';

const useActiveConversation = (conversations, conversationId, userId) => {
  const conversation =
    conversations.find(({ id }) => id === conversationId) ||
    DEFAULT_CONVERSATION;
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!conversation?.joined) return;

    const fetchConversationById = async () => {
      try {
        await dispatch(
          getConversationById({
            conversationId: conversation.id,
            userId,
          })
        ).unwrap();
      } catch (error) {
        setError(error);
      }
    };

    fetchConversationById();

    return () => setError(null);
  }, [conversationId]);

  const refetchConversation = async () => {
    setError(null);
    try {
      await dispatch(
        getConversationById({
          conversationId: conversation.id,
          userId,
        })
      ).unwrap();
    } catch (error) {
      setError(error);
    }
  };

  const sortedParticipants = [...conversation.participants].sort((a, b) => {
    if (a.id === userId) return 1;
    if (b.id === userId) return -1;
    return 0;
  });

  return {
    conversation: {
      ...conversation,
      participants: sortedParticipants,
    },
    loading: Boolean(conversation.joined && !error),
    error,
    refetchConversation,
  };
};

const DEFAULT_CONVERSATION = {
  id: '',
  messages: [],
  participants: [],
  unread: false,
  type: '',
};

export default useActiveConversation;
